import { PropsWithChildren } from "react";

import { useReportIsVerified } from "./useReportIsVerified";

type WhenVerifiedProps = PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

export function WhenVerified({ fallback, children }: WhenVerifiedProps) {
  const isVerified = useReportIsVerified();
  if (!isVerified) {
    return fallback;
  }
  return <>{children}</>;
}
